import { useEffect } from "react";
import { addMouse } from "../../utils/addMouse";

export default function Mouse() {
  useEffect(() => {
    addMouse();
  }, []);
  return (
    <>
      <div className="tf-mouse tf-mouse-outer"></div>
      <div className="tf-mouse tf-mouse-inner"></div>
    </>
  );
}
